import { FC } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { ListItemButton, ListItemIcon } from '@mui/material';

import Iconify from '@src/components/iconify';
import { NavEntryType } from '@src/types/main';

type NavItemMiniProps = {
  item: NavEntryType;
};

const NavItemMini: FC<NavItemMiniProps> = (props) => {
  const { item } = props;

  const location = useLocation();
  const isActive = location.pathname === item.path;

  return (
    <ListItemButton
      component={NavLink}
      to={item.path}
      aria-label={item.label}
      end
      sx={{
        justifyContent: 'center',
        borderRadius: 1,
        '& .MuiListItemIcon-root': {
          minWidth: 'auto',
        },
        '&.active': {
          backgroundColor: 'custom.background',
          color: 'primary.dark',
        },
      }}
    >
      <ListItemIcon>
        <Iconify
          data-testid="iconify"
          icon={item.icon}
          sx={{ color: isActive ? 'primary.dark' : 'custom.lightGrey' }}
        />
      </ListItemIcon>
    </ListItemButton>
  );
};

export default NavItemMini;
